import { httpsCallable, httpsCallableFromURL } from 'firebase/functions';
import { functions } from '../config/firebase';

/** Must stay below Cloud Function timeoutSeconds. */
const EXTRACT_VIP_CONTACTS_IMPORT_TIMEOUT_MS = 520_000;

const callableOptions = { timeout: EXTRACT_VIP_CONTACTS_IMPORT_TIMEOUT_MS };

function getExtractVipContactsImportCallable() {
  if (import.meta.env.DEV && typeof window !== 'undefined') {
    const url = `${window.location.origin}/__fb_functions/extractVipContactsImport`;
    return httpsCallableFromURL(functions, url, callableOptions);
  }
  return httpsCallable(functions, 'extractVipContactsImport', callableOptions);
}

/**
 * Parse VIP contacts CSV locally (simple files). Prefer {@link extractVipContactsImport} for Excel/Word/AI.
 * @param {string} text
 * @returns {Array<{ name: string, email: string, address: string }>}
 */
export function parseVipContactsCsv(text) {
  if (!text || typeof text !== 'string') return [];
  const lines = text.split(/\r?\n/).map((l) => l.trim()).filter(Boolean);
  const rows = [];
  for (let i = 0; i < lines.length; i++) {
    const line = lines[i];
    const parts = line.split(/[;,]/).map((s) => s.trim().replace(/^"|"$/g, ''));
    if (parts.length < 2) continue;
    const [name, email, ...rest] = parts;
    const em = String(email || '').trim().toLowerCase();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(em)) continue;
    if (i === 0 && /email/i.test(em) && /name|nom/i.test(String(name || ''))) continue;
    const address = rest.join(', ').trim();
    rows.push({ name: String(name || '').trim(), email: em, address });
  }
  return rows;
}

/**
 * @param {string} fileBase64
 * @param {string} fileName
 * @param {'fr'|'en'} locale
 * @returns {Promise<{ contacts: Array<{ name?: string, email: string, address?: string, notes?: string }> }>}
 */
export async function extractVipContactsImport(fileBase64, fileName, locale) {
  const fn = getExtractVipContactsImportCallable();
  const res = await fn({
    fileBase64,
    fileName,
    locale: locale === 'fr' ? 'fr' : 'en',
  });
  return res.data;
}
